import React, { useState, useEffect, useCallback } from 'react';
import { Phone, MessageCircle, PartyPopper, ShoppingBag, AlarmClock, RefreshCw, Flame } from 'lucide-react';
import { api, inr } from '../api';

export default function DailyWrapModule({ agent }) {
  const [s, setS] = useState(null);

  const load = useCallback(() => api.get(`/agents/${agent.id}/daily-summary`).then((r) => setS(r.data)), [agent.id]);
  useEffect(() => { load(); }, [load]);

  if (!s) return <p className="font-hand text-lg text-emerald-800/60 text-center py-4">Tallying your day…</p>;

  const rows = [
    { icon: Phone, label: 'Calls made', value: s.calls_made, cls: 'text-sky-700' },
    { icon: MessageCircle, label: 'WhatsApps sent', value: s.whatsapps_sent, cls: 'text-emerald-700' },
    { icon: PartyPopper, label: 'Leads converted', value: s.leads_converted, cls: 'text-amber-600' },
    { icon: ShoppingBag, label: 'Orders created', value: s.orders_created, cls: 'text-indigo-600' },
    { icon: AlarmClock, label: 'Pending follow-ups', value: s.pending_followups, cls: 'text-pink-700' },
  ];

  return (
    <div data-testid="daily-wrap-widget" className="space-y-2">
      <div className="flex items-center justify-between">
        <p className="font-hand text-lg text-emerald-900/80 font-bold">Today · {s.date}</p>
        <button data-testid="daily-wrap-refresh" onClick={load} className="p-1 rounded-full hover:bg-emerald-100 text-emerald-700 transition-colors">
          <RefreshCw size={13} />
        </button>
      </div>

      <div className="bg-white/80 border border-emerald-200 rounded-lg px-3 py-2 text-center">
        <p className="text-[10px] font-bold uppercase tracking-wider text-emerald-700/60">Revenue today</p>
        <p className="font-display font-extrabold text-2xl text-emerald-900" data-testid="daily-wrap-revenue">{inr(s.revenue_today)}</p>
      </div>

      <div className="space-y-1">
        {rows.map(({ icon: Icon, label, value, cls }) => (
          <div key={label} className="flex items-center justify-between bg-white/70 border border-emerald-200 rounded-lg px-2.5 py-1.5">
            <span className={`flex items-center gap-1.5 text-[11px] font-semibold text-slate-600`}>
              <Icon size={12} className={cls} /> {label}
            </span>
            <span className="font-display font-extrabold text-sm text-slate-900">{value}</span>
          </div>
        ))}
      </div>

      {s.overdue_followups > 0 ? (
        <p data-testid="daily-wrap-overdue" className="font-hand text-base font-bold text-red-600 bg-red-50 border border-red-200 rounded-lg px-2.5 py-1.5 flex items-center gap-1.5">
          <Flame size={13} /> {s.overdue_followups} overdue — clear before you clock out!
        </p>
      ) : (
        <p className="font-hand text-base text-emerald-800/70 text-center">All caught up · {s.active_leads} active leads for tomorrow 🌙</p>
      )}
    </div>
  );
}
